import { render, staticRenderFns } from "./CourseSectionTitle.vue?vue&type=template&id=407cd2c2&"
import script from "./CourseSectionTitle.vue?vue&type=script&lang=ts&"
export * from "./CourseSectionTitle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports